import { State } from './emailVerification.types';

export const initState: State = {
  isLoading: false,
  tokenVerifiedStatus: null,
};
